import * as React from "react";
import { SafeAreaController } from "@hiloenergie/capacitor-plugin-safe-area";
import { config } from "config";

const StateContext = React.createContext();

export const useSafeAreaInsetsState = () => {
  const context = React.useContext(StateContext);

  if (context === undefined)
    throw new Error(
      "Cannot use 'useSafeAreaInsetsState' outside of a SafeAreaInsetsProvider!",
    );

  return context;
};

const SafeAreaInsetsProvider = ({ children }) => {
  const [state, setState] = React.useState({
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
  });

  React.useEffect(() => {
    if (!config.isMobileApp) {
      return undefined;
    }

    document.querySelector("html").classList.add("mobile-app");

    SafeAreaController.addListener((insets) => {
      const safeInsets = {
        top: Number(insets?.top || 0),
        bottom: Number(insets?.bottom || 0),
        left: Number(insets?.left || 0),
        right: Number(insets?.right || 0),
      };
      setState(safeInsets);
    });

    SafeAreaController.load().then((insets) => {
      if (insets) {
        setState(insets);
        Object.keys(insets).forEach((key) => {
          document.documentElement.style.setProperty(
            `--capacitor-safe-area-inset-${key}`,
            `${insets[key]}px`,
          );
        });
      }
    });

    return () => {
      SafeAreaController.removeAllListeners();
      SafeAreaController.unload();
    };
  }, []);

  React.useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--safe-area-inset-top", `${state.top}px`);
    root.style.setProperty("--safe-area-inset-bottom", `${state.bottom}px`);
    root.style.setProperty("--safe-area-inset-left", `${state.left}px`);
    root.style.setProperty("--safe-area-inset-right", `${state.right}px`);
  }, [state.top, state.bottom, state.left, state.right]);

  return (
    <StateContext.Provider value={state}>{children}</StateContext.Provider>
  );
};

export default SafeAreaInsetsProvider;
